// other functions

Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
  var params = location.search.substr(1).split("&");

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split("=");

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(
        keyValue[1]
      );
    }
  }
}

// Update sort_by query parameter on select change
const sortByResult = document.querySelector("#sort-by");
if (sortByResult) {
  sortByResult.addEventListener("change", function (e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}

//classes
class FilterClass extends HTMLElement {
    constructor(){
        super();
        this._selector = '#filter-cat';
        this._state = '.state-cat';
        this._el = document.querySelector(this._selector);
        this._stateEl = document.querySelector(this._state);
        this._stateValue = '-';
        this.init()
    }

    init(){
        this._stateEl.innerHTML = this._stateValue;

        const changeState = _ => {
            this._stateValue == '+' 
                ? this._stateValue = '-'
                : this._stateValue = '+';
            this._stateEl.innerHTML = this._stateValue;
        }

        this._el.addEventListener("click", changeState.bind(this))
    }
}

class Sortby extends HTMLElement  {
    constructor(){
        super();
        this._selector = '.sort-by__dropdown';
        this._selectorItems = '.sort-by__dropdown-items'
        this._dom = document.querySelector(this._selector);
        this._domItems = document.querySelector(this._selectorItems);
        this._state = false;
        this.init()
    }

    render(){
        this._state == false 
            ? this._domItems.style.display = 'none' 
            : this._domItems.style.display = 'flex' 

    }

    init(){
        const updateState = _ => {
            console.log("updated");
            this._state == false 
                ? this._state = true 
                : this._state = false;

            this.render()
            console.log(this._state);
        }
        this._dom.addEventListener("click", updateState.bind(this))
        this.render() 
    }
}

class UpdateGridListView extends HTMLElement  {
    constructor() {
        super();
        //selectors for get view
        this._grid = '#view-as-tiles';
        this._list = '#view-as-stream';
        this._gridDom = document.querySelector(this._grid);
        this._listDom = document.querySelector(this._list);

         //selectors for update view
        this._selector = '.collection-listing__elements';
        this._dom = document.querySelector(this._selector);

        // component state and initiation
        this._state = 'collection-listing';
        this.init()
    }

    gridView(){
        this._dom.classList.add('collection-listing')
        this._dom.classList.remove('collection-listing-stream')
    }

    listView(){
        this._dom.classList.add('collection-listing-stream')
        this._dom.classList.remove('collection-listing')
    }

    getView(){
        this._gridDom.addEventListener("click", this.gridView.bind(this))
        this._listDom.addEventListener("click", this.listView.bind(this))
    }

    init(){
        // verify selectors
        this._gridDom && this._listDom 
            && this.getView()

        //Set State
        this._dom && this._dom.classList.contains('collection-listing') 
            ? this._state = 'collection-listing'
            : this._state = 'collection-listing-stream';
    }
}
class QuickView extends HTMLElement  {
    constructor() {
        super();
        this.selector = document.querySelector(".quickbuy-container");
        console.log(this.selector);
        setTimeout(() => {
            console.log(this.selector);
        }, 10000);
    }

}

customElements.define("filter-class", FilterClass);
customElements.define("sort-by", Sortby);
customElements.define("update-gridlistview", UpdateGridListView);
//customElements.define("quick-view", QuickView);

